import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, TrendingUp, ChevronRight, Search } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

export default function MobileCRMOpportunitiesPage() {
  const navigate = useNavigate();
  const [opps, setOpps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    axios.get(`${API}/crm/opportunities`).then(r => setOpps(r.data || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const filtered = opps.filter(o => !search || (o.customer_name || o.name || '').toLowerCase().includes(search.toLowerCase()));
  const totalPipeline = opps.reduce((s, o) => s + (o.revenue || o.value || 0), 0);

  if (loading) return <div className="mobile-page"><div className="mobile-loading"><div className="mobile-spinner" /></div></div>;

  return (
    <div className="mobile-page">
      <button className="mobile-back-btn" onClick={() => navigate('/mobile/more')}><ArrowLeft size={18} /> More</button>
      <div className="mobile-page-title" style={{ marginBottom: 12 }}>Opportunities</div>
      <div style={{ position: 'relative', marginBottom: 14 }}>
        <Search size={16} style={{ position: 'absolute', left: 12, top: 13, color: '#8e8e93' }} />
        <input className="mobile-input" placeholder="Search..." value={search} onChange={e => setSearch(e.target.value)} style={{ paddingLeft: 36 }} />
      </div>
      <div className="mobile-kpi-row" style={{ marginBottom: 14 }}>
        <div className="mobile-kpi-card blue"><div className="mobile-kpi-label">Total</div><div className="mobile-kpi-value">{opps.length}</div></div>
        <div className="mobile-kpi-card green"><div className="mobile-kpi-label">Pipeline</div><div className="mobile-kpi-value">${(totalPipeline / 1000).toFixed(0)}k</div></div>
      </div>
      {filtered.length === 0 ? <div className="mobile-empty-state"><TrendingUp /><p>No opportunities</p></div> : (
        filtered.map(opp => (
          <div key={opp.opportunity_id || opp.id} className="mobile-wo-card" style={{ borderLeftColor: '#007aff', cursor: 'pointer' }} onClick={() => navigate(`/mobile/crm/opportunities/${opp.opportunity_id || opp.id}`)}>
            <div className="mobile-wo-header"><div><div className="mobile-wo-item-name">{opp.customer_name || opp.name}</div><div className="mobile-wo-number">{opp.name || opp.description}</div></div><span className="mobile-status-badge scheduled">{opp.stage || 'N/A'}</span></div>
            <div className="mobile-wo-meta"><span className="mobile-wo-meta-item">${((opp.revenue || opp.value || 0) / 1000).toFixed(0)}k</span><span className="mobile-wo-meta-item">{opp.probability || 0}% prob</span></div>
          </div>
        ))
      )}
    </div>
  );
}
